<template lang="html">
  <div class="Todos">
    <h1>Työtehtävät</h1>
    <Add_item  v-on="$listeners"/>
    <Todos_list :todos="todos" v-on="$listeners" @select_task="select_task"/>
    <b-button size="sm" variant="warning" @click="$emit('del_all_tasks')">
        Tyhjennä tehtävä lista
    </b-button>
    <todo_modals :selected="selected"/>
  </div>
</template>

<script>
import Todos_list from './Todos_list';
import Add_item from './Add_item';
import todo_modals from './todo_modals';

export default {
  name: "Todos",
  components: {
    Todos_list,
    Add_item,
    todo_modals,
  },
  data(){
    return {
      selected:"",
    }
  },
  props:["todos"],
  methods:{
    select_task(task){
      this.selected = task;
    }
  }
}
</script>

<style lang="css" scoped>
.Todos{
  width: 50%;
  max-width: 500px;
}
</style>
